<template>
  <table-configuration-provider
    :default-config="defaultConfig"
    :default-columns="columns"
    :filters="filters"
    class="column no-wrap col q-mx-sm"
    @saveConfig="onSaveConfig"
  >
    <template #default="props">
      <lwf-filters
        v-model="filters"
        :inline="$q.screen.gt.sm"
        :filters="optFilters"
        :filters-preset="pageConfig.filtersPreset"
        position="top"
        :offset="[0, -24]"
        class="col-auto"
        @savePreset="onSaveFilterPreset"
      />
      <table-agency-contract-customer
        :config="props.config"
        class="sticky-table col full-width column no-wrap"
      >
        <template #top-right>
          <table-configuration-provider-top-right :props="props" />
        </template>
      </table-agency-contract-customer>
    </template>
  </table-configuration-provider>
</template>

<script>
import TableConfigurationProviderTopRight from 'components/Table/TableConfigurationProviderTopRight'
import LwfFilters from 'components/core/LwfFilters'
import TableConfigurationProvider from 'components/Table/TableConfigurationProvider'
import { CONTRACT_ACTIVE_STATUS, CONTRACT_TYPES_CUSTOMER, DATA_AGENCY_CONTRACT_COLUMNS } from '@/consts/data/contract'
import pagePersitantFilterMixin from '@/mixins/pagePersistantFilterMixin'
import { mapSelectFilters } from '@/utils/ui'
import TableAgencyContractCustomer from 'components/Table/TableAgencyContractCustomer'

export default {
  name: 'ContractsCustomer',
  components: {
    TableAgencyContractCustomer,
    TableConfigurationProviderTopRight,
    LwfFilters,
    TableConfigurationProvider
  },
  PERSISTENCE_KEY: 'contractCustomer',
  mixins: [pagePersitantFilterMixin],
  props: {
    defaultFilters: {
      type: Object,
      default: _.stubObject,
      required: false
    }
  },
  data () {
    return {
      filters: Object.assign({}, this.defaultFilters)
    }
  },
  computed: {
    columns () {
      return DATA_AGENCY_CONTRACT_COLUMNS
        .filter(
          ({ contractTypes = [] }) =>
            contractTypes.length === 0 || contractTypes.indexOf(CONTRACT_TYPES_CUSTOMER) !== -1
        )
    },
    optFilters () {
      return [
        'dateRange',
        'customers',
        ...[
          'contractStatus'
        ].map(mapSelectFilters)
      ]
    },
    defaultConfig () {
      return {
        columns: this.columns.map((c) => c.name),
        filters: {
          status: CONTRACT_ACTIVE_STATUS
        },
        pagination: {
          rowsPerPage: 25,
          sortBy: 'createdAt',
          descending: true
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
